import UserRole from "../../../../../common/types/user-role";
import UserPermissionsDefinition from "../../../../../common/utils/user/permissions/user-permissions-definition";

export type OrderFinishedListingUserPermissionOption =
  "hasAccessToFleetPartnerColumn";

export type OrderFinishedListingUserPermissionsDefinition =
  UserPermissionsDefinition<OrderFinishedListingUserPermissionOption>;

const orderFinishedListingUserPermissionDefinition: OrderFinishedListingUserPermissionsDefinition =
  {
    hasAccessToFleetPartnerColumn: [
      UserRole.ADMIN,
      UserRole.RAILY_OFFICER,
      UserRole.OPERATOR,
    ],
  };

export default orderFinishedListingUserPermissionDefinition;
